import { put, takeEvery } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { setUser, setAllUsers } from 'actions/user';
import { signInFormSubmit } from 'api/signIn';
import { getUserJobPosts, getAllJobPosts } from 'api/jobPosts';
import { getAllUsers } from 'api/admin';
import { setUserJobPosts, setAllJobPosts } from 'modules/JobPosts/actions';
import { setAdmin } from 'modules/Admin/actions';
import { ADMIN, RECRUITER } from 'constants/index';
import { startSignInSubmit, resolveSignInSubmit } from './actions';

export function* signInSubmitSaga(action: any) {
  try {
    const user = yield signInFormSubmit(action.payload);

    const { role, token, status } = user.data;

    if (role === ADMIN) {
      yield put(resolveSignInSubmit());

      yield put(setAdmin(user.data));

      const allUsers = yield getAllUsers(token, { order: ['createdAt DESC'] });
      yield put(setAllUsers(allUsers.data));

      yield put(push('/admin'));
    }

    if (role !== ADMIN && status === 'ACTIVE') {
      yield put(resolveSignInSubmit());

      yield put(setUser(user.data));

      if (role === RECRUITER && status === 'ACTIVE') {
        const allJobPosts = yield getAllJobPosts(
          token,
          JSON.stringify({ order: ['createdAt DESC'] })
        );
        yield put(setAllJobPosts(allJobPosts.data.jobs));
      }

      const userJobPosts = yield getUserJobPosts(role, token);

      yield put(setUserJobPosts(userJobPosts.data.jobs));

      yield put(push('/dashboard'));
    }
  } catch (error) {
    yield put(resolveSignInSubmit(error.response));
  }
}

export default function* signInSaga() {
  yield takeEvery(startSignInSubmit, signInSubmitSaga);
}
